import { Text } from "@chakra-ui/react"
import type { NextPage } from "next"

import JSONPretty from "@features/formatters/json-pretty"

import Page from "@shared/ui/page"

const JSONPrettyPage: NextPage = () => {
  return (
    <Page title={"JSON-formatter"}>
      <Text>Paste your JSON below:</Text>
      <JSONPretty />
    </Page>
  )
}

export default JSONPrettyPage
